import React, {FC} from 'react';
import {withStyles} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {ChipContainer, SelectableChip} from '@epic-ui/components';

import {TimeScale} from '../../../../../../types';

export interface Option {
    value: TimeScale;
    label: string;
}

export interface IntervalRadioGroupProps {
    options: Option[];
    value: Option;
    onChange: (option: Option) => void;
}

const useStyles = makeStyles({
    root: {
        direction: 'ltr',
        flexWrap: 'nowrap'
    }
});

const StyledSelectableChip = withStyles(theme => ({
    root: {
        padding: theme.spacing(0, 1),

        '& svg': {
            margin: 0
        },
        '& span': {
            padding: theme.spacing(0, 1)
        }
    }
}))(SelectableChip);

const IntervalRadioGroup: FC<IntervalRadioGroupProps> = ({
    options,
    value,
    onChange
}: IntervalRadioGroupProps) => {
    const classes = useStyles();

    const handleChange = (option: Option) => () => {
        if (option !== value) {
            onChange(option);
        }
    };

    return (
        <ChipContainer className={classes.root}>
            {options.map(option => {
                const {value: optionValue, label} = option;

                return (
                    <StyledSelectableChip
                        variant="outlined"
                        key={optionValue}
                        checked={value === option}
                        label={label}
                        onChange={handleChange(option)}
                    />
                );
            })}
        </ChipContainer>
    );
};

export default IntervalRadioGroup;
